var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"estate-duty-costs-container"},[_c('InJourneyAccordion',{attrs:{"accordionData":_vm.accordionData,"padding":_vm.padding}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }